export const DATE_FORMAT_TYPE_I = 'dd/mm/yyyy';
export const DATE_FORMAT_TYPE_II = 'DD/MM/YYYY';
export const DATE_FORMAT_TYPE_III = 'YYYY-MM-DD';
export const DATE_FORMAT_TYPE_IV = 'DD-MM-YYYY';
export const DATE_FORMAT_TYPE_V = 'DD/MM';
